module.exports = __webpack_public_path__ + "assets/img/profile-photo.37bfd02b.png";